var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#08090B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 4,
    height: 15,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 4,
    height: 15,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/Pause Button.9cfed2adb5d3a1e43b111f3dab5d66bc.svg";
export { ForwardRef as ReactComponent };